/**
 * This file is to map delay condition , from and to BE structure, it should contain at least two functions, one that maps
 * from BE to FE structure, and the other one that maps from FE to BE structure
 */
import { ActionEvents } from "assets/js/scenes/automations/containers/editor/EventsConfigs";
import {
	getEdge,
	getEndCoachmarkNode,
	getNextTarget,
	getShadowsForStep,
} from "assets/js/scenes/automations/containers/editor/utils/utils";
import { getAllPreviousEventsByEventType } from "assets/js/scenes/automations/containers/editor/utils/utils";
import { limitsFeaturesAccess, LIMIT_FEATURE } from "assets/js/utils/LimitsAndFeatures";

const parseBEUpdateContactTagsToFE = (
	automation,
	mainStep,
	subStep,
	targetId
) => {
	const events = [];
	const eventConfigs = ActionEvents().filter(
		(event) => event.id == "updateContactTags"
	)[0];
	events.push({
		id: mainStep.name,
		position: {
			x: 0,
			y: 0,
		},
		data: {
			name: eventConfigs.name,
			desc: eventConfigs.desc,
			type: "action",
			tileTitle: eventConfigs.tileTitle,
			id: mainStep.name,
			baseId: "updateContactTags",
			tags: mainStep.args.tags,
			initialElement: false,
			tagAction:
				mainStep.action == "Contact.Tag"
					? "tag"
					: mainStep.action == "Contact.Untag"
						? "untag"
						: "",
			shadows: getShadowsForStep(automation, mainStep.name),
		},
		type: "editorNode",
	});
	const links = [];
	if (targetId) {
		links.push(getEdge("custom", mainStep.name, targetId));
	} else {
		const endCoachmark = getEndCoachmarkNode(0, 0);
		events.push(endCoachmark);
		links.push(getEdge("custom", mainStep.name, endCoachmark.id));
	}
	return {
		events: events,
		links: links,
	};
};
const parseFEUpdateContactTagsToBE = (FEEvent, connectedEdges, events) => {
	let shadows = [];
	let inTos = [];

	const addFilterStepIfNeeded = () => {
		const previousSteps = getAllPreviousEventsByEventType(
			FEEvent.id,
			"type",
			"condition"
		);
		if (checkIfRecurringAutomation && (previousSteps.length < 1 || previousSteps[0]?.data?.baseId !== "filterSet")) {
			return [{
				name: "set_filter",
				action: "Variable.Set",
				args: {
					"input.data.filter": {
						"and": [
							{
								"or": [
									{
										"eq": {
											"status": "active"
										}
									}
								]
							}
						]
					}
				}
			}];
		} else {
			return [];
		}

	};
	const checkIfRecurringAutomation = events.find(event => event.data.baseId == "onSchedule");
	const hasMultipleListsAsTriggers = events.filter((e) => e.data.type == "trigger" && e.data.baseId !== "manual").length > 1 && limitsFeaturesAccess(LIMIT_FEATURE.USE_EMAIL_API);

	if (FEEvent.data.shadows) shadows = [...FEEvent.data.shadows];
	inTos = events
		.filter((e) => e.data.baseId == "loop")
		.filter((e) => e.data.goTo == FEEvent.id);
	if (inTos.length > 0) inTos = inTos.map((e) => `${e.id}_loop`);
	return {
		main: [
			{
				steps: [
					{
						name: `${FEEvent.id}`,
						action: "SubAutomation.Call",
						args: {
							sub_automation: FEEvent.id,
						},
						next: "end",
						shadows: shadows,
						inTos: inTos,
					},
				],
			},
		],
		sub: [
			{
				name: FEEvent.id,
				params: [],
				type: !checkIfRecurringAutomation ? "contactTag" : "recurring_contactTag",
				steps: [
					...addFilterStepIfNeeded(),
					{
						name: FEEvent.id,

						action:
							FEEvent.data.tagAction == "tag"
								? "Contact.Tag"
								: FEEvent.data.tagAction == "untag"
									? "Contact.Untag"
									: "",
						args: {
							tags: FEEvent.data.tags,
							...(checkIfRecurringAutomation && { json: "${input.data.filter}" }),
							...(hasMultipleListsAsTriggers && { list_id: "${input.data.listId}" })
						},

						next: getNextTarget(connectedEdges, events),
					},
				],
			},
		],
		reusableSubAutomations: ["emit_next_step"],
	};
};

export { parseBEUpdateContactTagsToFE, parseFEUpdateContactTagsToBE };
